import { createReducer } from 'utils/reduxCreators';
import { fetchFacilityById } from 'services/facilities';
import {
  setEntitiesWithNormalisation,
  SET_NORMALIZED_ENTITIES,
} from './normalizer';
import { facilitySchema } from './schemas';

const initialState = {
  entities: {},
};

export default createReducer(initialState, {
  [SET_NORMALIZED_ENTITIES]: (state, { payload }) => {
    if (payload.entities.facilities) {
      return {
        ...state,
        entities: {
          ...payload.entities.facilities,
        },
      };
    }
    return state;
  },
});

export const getFacilityById = (facilityId) => async (dispatch, getState) => {
  const facility = await fetchFacilityById(facilityId);
  dispatch(setEntitiesWithNormalisation(facility, facilitySchema));
};

export const getFacilityByAdfitNo = (adfitNo) => async (dispatch, getState) => {
  const { customerDetails } = getState();
  //Ask for an api that can get the facility by the adfitNo directly.
  if (customerDetails.adfitNo !== adfitNo) {
    throw new Error('Different Account loaded');
  }
  const { facility: facilityId } = customerDetails;
  return dispatch(getFacilityById(facilityId));
};
